import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ChevronRight({ iconClass, width, height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 8 13"
      className={iconClass}
      width={width}
      height={height}
    >
      <path d="M7.30078 6.39844L6.83594 6.86328L1.36719 12.332L0.902344 12.7969L0 11.8672L0.464844 11.4023L5.46875 6.39844L0.464844 1.39453L0 0.929688L0.902344 0L1.36719 0.464844L6.83594 5.93359L7.30078 6.39844Z" />
    </svg>
  );
}
